import {ActionType} from '../../model/model'
import {LoginData} from '../../model/model'

export const loginUserAction = (data: LoginData, callback: void) => {
  return {
    type: ActionType.LOGIN_USER,
    payload: {data, callback},
  }
}
